import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import PortfolioItem from "./PortfolioItem";

// Large project media lives in public/portfolio and is fetched on demand,
// instead of being bundled into the JS build via webpack imports.
const image0 = "/portfolio/projectBachelor/Capture1.PNG";
const image0Fig1 = "/portfolio/projectBachelor/Capture2.PNG";
const image1 = "/portfolio/projectPCBBuck/img1.png";
const image2 = "/portfolio/projectMeteoStation/ESP32-with-DHT11DHT22-Temperature-and-Humidity-Sensor-using-Arduino-IDE.jpg";
const image3 = "/portfolio/project-03.jpg";
const image3Fig1 = "/portfolio/cukProjectFiles/Poza_Simulare_Cuk_Simulink.PNG";
const image3Gallery1 = "/portfolio/cukProjectFiles/Curentii_Primari_Si_Secundari_Transformator.PNG";
const image3Gallery2 = "/portfolio/cukProjectFiles/Forme_Unda_Curent_si_Tensiune_Iesire.PNG";
const image3Gallery3 = "/portfolio/cukProjectFiles/Forme_Unda_Curenti_Inductivi_Tensiuni_Capacitive.PNG";
const image3Gallery4 = "/portfolio/cukProjectFiles/Grafic_Raport_Static_de_Conversie.PNG";
const image3Gallery5 = "/portfolio/cukProjectFiles/Poza_forma_unda_Curent_Iesire.PNG";
const image3Gallery6 = "/portfolio/cukProjectFiles/Sarcina_Tensiune_Tranzistor.PNG";
const image3Gallery7 = "/portfolio/cukProjectFiles/Tensiuni_Transformator_Primar_Secundar.PNG";
const cukPDF = "/portfolio/cukProjectFiles/Calcule_pe_foaie_Convertor_Cuk.pdf";
const image4 = "/portfolio/project-04.jpg";
const image4Fig1 = "/portfolio/project-04-fig1.jpg";
const image5 = "/portfolio/projectClawMachine/diagnostic-gui.jpg";
const image5Fig1 = "/portfolio/projectClawMachine/raspberry-pi-5-system.jpg";
const image5Gallery1 = "/portfolio/projectClawMachine/legacy-control-android-board.jpg";
const image5Gallery2 = "/portfolio/projectClawMachine/legacy-android-control-in-work.jpg";
const image5Gallery3 = "/portfolio/projectClawMachine/legacy-l298n-motor-driver.jpg";
const image5Gallery4 = "/portfolio/projectClawMachine/legacy-esp32-led-strip.jpg";
const image5Gallery5 = "/portfolio/projectClawMachine/drivers-wire-management.jpg";

const Portfolio = () => {
  const { t } = useTranslation();
  const [selectedProject, setSelectedProject] = useState(null);
  const [modalImage, setModalImage] = useState(null);

  const portfolioData = [
    {
      id: 0,
      image: image0,
      title: t("portfolio.project0.title"),
      shortDescription: t("portfolio.project0.shortDescription"),
      fullDescription: t("portfolio.project0.fullDescription"),
      figureImage: image0Fig1,
      figureCaption: t("portfolio.project0.figureCaption"),
      roleResponsibilities: t("portfolio.project0.roleResponsibilities"),
      technologies: t("portfolio.project0.technologies", { returnObjects: true }),
      challenges: t("portfolio.project0.challenges"),
      codeSection: null,
      challengeDetail: t("portfolio.project0.challengeDetail", { returnObjects: true }),
      outcome: t("portfolio.project0.outcome"),
      galleryImages: null,
      pdfLink: null,
      githubLink: null,
      externalLink: null,
    },
    {
      id: 1,
      image: image1,
      title: t("portfolio.project1.title"),
      shortDescription: t("portfolio.project1.shortDescription"),
      fullDescription: t("portfolio.project1.fullDescription"),
      figureImage: null,
      figureCaption: null,
      roleResponsibilities: t("portfolio.project1.roleResponsibilities"),
      technologies: t("portfolio.project1.technologies", { returnObjects: true }),
      challenges: t("portfolio.project1.challenges"),
      codeSection: null,
      challengeDetail: t("portfolio.project1.challengeDetail", { returnObjects: true }),
      outcome: t("portfolio.project1.outcome"),
      galleryImages: null,
      pdfLink: null,
      githubLink: null,
      externalLink: "https://student108403.autodesk360.com/g/shares/SH512d4QTec90decfa6e01b5a3ebc8253ece",
    },
    {
      id: 2,
      image: image2,
      title: t("portfolio.project2.title"),
      shortDescription: t("portfolio.project2.shortDescription"),
      fullDescription: t("portfolio.project2.fullDescription"),
      figureImage: null,
      figureCaption: null,
      roleResponsibilities: t("portfolio.project2.roleResponsibilities"),
      technologies: t("portfolio.project2.technologies", { returnObjects: true }),
      challenges: t("portfolio.project2.challenges"),
      codeSection: null,
      challengeDetail: t("portfolio.project2.challengeDetail", { returnObjects: true }),
      outcome: t("portfolio.project2.outcome"),
      galleryImages: null,
      pdfLink: null,
      githubLink: t("portfolio.project2.githubLink"),
      externalLink: null,
    },
    {
      id: 3,
      image: image3,
      title: t("portfolio.project3.title"),
      shortDescription: t("portfolio.project3.shortDescription"),
      fullDescription: t("portfolio.project3.fullDescription"),
      figureImage: image3Fig1,
      figureCaption: t("portfolio.project3.figureCaption"),
      roleResponsibilities: t("portfolio.project3.roleResponsibilities"),
      technologies: t("portfolio.project3.technologies", { returnObjects: true }),
      challenges: t("portfolio.project3.challenges"),
      codeSection: t("portfolio.project3.codeSection"),
      challengeDetail: t("portfolio.project3.challengeDetail", { returnObjects: true }),
      outcome: t("portfolio.project3.outcome"),
      galleryImages: [
        { src: image3Gallery1, caption: "Transformer primary and secondary currents" },
        { src: image3Gallery2, caption: "Output current and voltage waveforms" },
        { src: image3Gallery3, caption: "Inductive currents and capacitive voltages" },
        { src: image3Gallery4, caption: "Static conversion ratio graph" },
        { src: image3Gallery5, caption: "Output current waveform detail" },
        { src: image3Gallery6, caption: "Transistor voltage under load" },
        { src: image3Gallery7, caption: "Transformer primary and secondary voltages" },
      ],
      pdfLink: cukPDF,
      githubLink: null,
      externalLink: null,
    },
    {
      id: 4,
      image: image4,
      title: t("portfolio.project4.title"),
      shortDescription: t("portfolio.project4.shortDescription"),
      fullDescription: t("portfolio.project4.fullDescription"),
      roleResponsibilities: t("portfolio.project4.roleResponsibilities"),
      figureImage: image4Fig1,
      figureCaption: t("portfolio.project4.figureCaption"),
      technologies: t("portfolio.project4.technologies", { returnObjects: true }),
      challenges: t("portfolio.project4.challenges"),
      codeSection: t("portfolio.project4.codeSection"),
      challengeDetail: t("portfolio.project4.challengeDetail", { returnObjects: true }),
      outcome: t("portfolio.project4.outcome"),
      githubLink: t("portfolio.project4.githubLink"),
      externalLink: null,
    },
    {
      id: 5,
      image: image5,
      title: t("portfolio.project5.title"),
      shortDescription: t("portfolio.project5.shortDescription"),
      fullDescription: t("portfolio.project5.fullDescription"),
      figureImage: image5Fig1,
      figureCaption: t("portfolio.project5.figureCaption"),
      roleResponsibilities: t("portfolio.project5.roleResponsibilities"),
      technologies: t("portfolio.project5.technologies", { returnObjects: true }),
      challenges: t("portfolio.project5.challenges"),
      codeSection: t("portfolio.project5.codeSection"),
      challengeDetail: t("portfolio.project5.challengeDetail", { returnObjects: true }),
      outcome: t("portfolio.project5.outcome"),
      galleryTitle: t("portfolio.project5.galleryTitle"),
      galleryImages: [
        { src: image5Gallery1, caption: t("portfolio.project5.gallery.controlAndAndroidBoard") },
        { src: image5Gallery2, caption: t("portfolio.project5.gallery.androidControlInWork") },
        { src: image5Gallery3, caption: t("portfolio.project5.gallery.l298nDrivers") },
        { src: image5Gallery4, caption: t("portfolio.project5.gallery.esp32LedStrip") },
        { src: image5Gallery5, caption: t("portfolio.project5.gallery.driversAndWiring") },
      ],
      pdfLink: null,
      githubLink: null,
      externalLink: null,
    },
  ];

  const handleProjectClick = (project) => {
    setSelectedProject(project);
  };

  const handleBackClick = () => {
    setSelectedProject(null);
  };

  if (selectedProject) {
    return (
      <section>
        <div>
          <button
            onClick={handleBackClick}
            className="flex items-center gap-2 text-cyan hover:text-text mb-6 font-mono text-xs uppercase tracking-wide transition"
          >
            <FaArrowLeft />
            <span>{t("portfolio.backToProjects")}</span>
          </button>

          <div className="border border-border rounded overflow-hidden">
            <div className="w-full h-64 md:h-96 bg-surfaceHi overflow-hidden">
              <img
                src={selectedProject.image}
                alt={selectedProject.title}
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="p-8">
              <p className="font-mono text-xs text-muted mb-2">
                PROJ-{String(selectedProject.id).padStart(2, "0")}
              </p>
              <h2 className="text-3xl text-text font-semibold mb-4">
                {selectedProject.title}
              </h2>

              <div className="mb-6">
                <h3 className="font-mono text-xs uppercase tracking-wide text-muted mb-3">
                  {t("portfolio.overview")}
                </h3>
                <p className="text-[1.0625rem] leading-[1.7] text-prose md:text-lg md:leading-[1.75]">
                  {selectedProject.fullDescription}
                </p>
              </div>

              {selectedProject.figureImage && (
                <div className="mb-6 flex flex-col items-center">
                  <img
                    src={selectedProject.figureImage}
                    alt={selectedProject.figureCaption}
                    className="w-full md:w-1/2 rounded border border-border mb-2 cursor-pointer hover:opacity-90 transition-opacity"
                    onClick={(e) => {
                      e.preventDefault();
                      setModalImage(selectedProject.figureImage);
                    }}
                  />
                  <p className="text-sm text-muted italic text-center leading-relaxed mx-auto">
                    {selectedProject.figureCaption}
                  </p>
                </div>
              )}

              {selectedProject.roleResponsibilities && (
                <div className="mb-6">
                  <h3 className="font-mono text-xs uppercase tracking-wide text-muted mb-3">
                    {t("portfolio.roleResponsibilities")}
                  </h3>
                  <p className="text-[1.0625rem] leading-[1.7] text-prose md:text-lg md:leading-[1.75]">
                    {selectedProject.roleResponsibilities}
                  </p>
                </div>
              )}

              <div className="mb-6">
                <h3 className="font-mono text-xs uppercase tracking-wide text-muted mb-3">
                  {t("portfolio.technologiesUsed")}
                </h3>
                <div className="flex flex-wrap gap-2">
                  {selectedProject.technologies.map((tech, idx) => (
                    <span
                      key={idx}
                      className="font-mono text-xs px-2.5 py-1 rounded border border-border text-text"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mb-6">
                <h3 className="font-mono text-xs uppercase tracking-wide text-muted mb-3">
                  {t("portfolio.challenges")}
                </h3>
                <p className="text-[1.0625rem] leading-[1.7] text-prose md:text-lg md:leading-[1.75]">
                  {selectedProject.challenges}
                </p>
              </div>

              {selectedProject.codeSection && (
                <div className="mb-6">
                  <h3 className="font-mono text-xs uppercase tracking-wide text-muted mb-3">
                    {t("portfolio.codeImplementation")}
                  </h3>
                  <pre className="bg-surfaceHi text-text p-4 rounded border border-border overflow-x-auto text-sm font-mono leading-relaxed">
                    {selectedProject.codeSection}
                  </pre>
                </div>
              )}

              {selectedProject.challengeDetail && (
                <div className="mb-6 bg-surface p-6 rounded border-l-2 border-amber">
                  <h3 className="text-lg text-text font-semibold mb-4">
                    {selectedProject.challengeDetail.title}
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <h4 className="font-mono text-xs uppercase tracking-wide text-amber mb-2">
                        {t("portfolio.situation")}
                      </h4>
                      <p className="text-[1.0625rem] leading-[1.7] text-prose md:text-lg md:leading-[1.75]">
                        {selectedProject.challengeDetail.situation}
                      </p>
                    </div>
                    <div>
                      <h4 className="font-mono text-xs uppercase tracking-wide text-amber mb-2">
                        {t("portfolio.action")}
                      </h4>
                      <p className="text-[1.0625rem] leading-[1.7] text-prose md:text-lg md:leading-[1.75]">
                        {selectedProject.challengeDetail.action}
                      </p>
                    </div>
                    <div>
                      <h4 className="font-mono text-xs uppercase tracking-wide text-amber mb-2">
                        {t("portfolio.result")}
                      </h4>
                      <p className="text-[1.0625rem] leading-[1.7] text-prose md:text-lg md:leading-[1.75]">
                        {selectedProject.challengeDetail.result}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <div className="mb-6">
                <h3 className="font-mono text-xs uppercase tracking-wide text-muted mb-3">
                  {t("portfolio.outcome")}
                </h3>
                <p className="text-[1.0625rem] leading-[1.7] text-prose md:text-lg md:leading-[1.75]">
                  {selectedProject.outcome}
                </p>
              </div>

              {selectedProject.galleryImages && selectedProject.galleryImages.length > 0 && (
                <div className="mb-6">
                  <h3 className="font-mono text-xs uppercase tracking-wide text-muted mb-4">
                    {selectedProject.galleryTitle || "Simulation Results & Waveforms"}
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                    {selectedProject.galleryImages.map((img, idx) => (
                      <div key={idx} className="relative group">
                        <img
                          src={img.src}
                          alt={img.caption}
                          className="w-full h-48 object-cover rounded border border-border cursor-pointer hover:opacity-90 transition-opacity"
                          onClick={(e) => {
                            e.preventDefault();
                            setModalImage(img.src);
                          }}
                        />
                        <p className="text-xs text-muted mt-2 text-center">
                          {img.caption}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selectedProject.pdfLink && (
                <div className="mb-6 flex justify-center">
                  <a
                    href={selectedProject.pdfLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded border border-cyan text-cyan hover:bg-cyan hover:bg-opacity-10 transition"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                    </svg>
                    <span>View Calculation Sheet (PDF)</span>
                  </a>
                </div>
              )}

              {(selectedProject.githubLink || selectedProject.externalLink) && (
                <div className="flex flex-wrap gap-4 pt-6 border-t border-border">
                  {selectedProject.githubLink && (
                    <a
                      href={selectedProject.githubLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 rounded bg-amber text-bg font-medium hover:brightness-110 transition"
                    >
                      <FaGithub />
                      <span>{t("portfolio.viewOnGithub")}</span>
                    </a>
                  )}
                  {selectedProject.externalLink && (
                    <a
                      href={selectedProject.externalLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 rounded border border-border text-text hover:border-cyan hover:text-cyan transition"
                    >
                      <FaExternalLinkAlt />
                      <span>View in Fusion 360</span>
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {modalImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
            onClick={() => setModalImage(null)}
          >
            <div className="relative max-w-7xl max-h-full">
              <button
                onClick={() => setModalImage(null)}
                className="absolute top-4 right-4 text-white text-4xl font-bold hover:text-gray-300 transition-colors z-10"
                aria-label="Close"
              >
                ×
              </button>
              <img
                src={modalImage}
                alt="Full size view"
                className="max-w-full max-h-screen object-contain"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
        )}
      </section>
    );
  }

  return (
    <>
      <section>
        <div className="flex flex-wrap -mx-2">
          {portfolioData.map((portfolio) => (
            <PortfolioItem
              portfolio={portfolio}
              key={portfolio.id}
              onClick={() => handleProjectClick(portfolio)}
            />
          ))}
        </div>
      </section>

      {modalImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setModalImage(null)}
        >
          <div className="relative max-w-7xl max-h-full">
            <button
              onClick={() => setModalImage(null)}
              className="absolute top-4 right-4 text-white text-4xl font-bold hover:text-gray-300 transition-colors z-10"
              aria-label="Close"
            >
              ×
            </button>
            <img
              src={modalImage}
              alt="Full size view"
              className="max-w-full max-h-screen object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Portfolio;
